import React from 'react';
import { Box, List, Grid, ListItem, Typography, ListItemText } from '@material-ui/core';
import i18n from 'i18n-js';
import { formatAmount } from 'utils';
import PropTypes from 'prop-types';
import Loading from 'components/Loading';
import { Card, CollapseCard } from 'components/UI';
import { useSelector } from 'react-redux';
import { useStyles, collapseCardStyles, listTextStyles } from './InvoiceItems.styled';

const ListTitleComponent = ({ title, total }) => {
  const classes = useStyles();
  return (
    <Grid container className={classes.titleRow}>
      <span style={{ flexGrow: 1, textAlign: 'left', marginRight: '5px' }}>{title}</span>
      <span style={{ flexGrow: 0 }} data-cy="auth-hold-title-description">
        {i18n.t('invoice.total_info', {
          total: formatAmount(total),
        })}
      </span>
    </Grid>
  );
};

const ItemComponent = ({ item }) => {
  const collapseCardClasses = collapseCardStyles();
  const listClasses = listTextStyles();
  const classes = useStyles();

  const {
    description,
    unit_price,
    quantity,
    q_humanized,
    line_pre_tax: total,
    invoice_item_type: {
      name,
      description: itemDesc,
      units: { total: unit },
    },
  } = item;

  const invoiceItemInfo = [
    { label: i18n.t('common.description'), value: description || itemDesc || '--' },
    {
      label: i18n.t('invoice.unit_price'),
      value: unit_price != null ? `$${formatAmount(unit_price)}` : '--',
    },
    {
      label: i18n.t('invoice.quantity'),
      value:
        q_humanized !== undefined && quantity !== undefined ? `${q_humanized} (${quantity})` : '--',
    },
    { label: i18n.t('invoice.unit'), value: unit || '--' },
  ];

  return (
    <CollapseCard
      title={<ListTitleComponent data-cy="auth-hold-item-element" title={name} total={total} />}
      customClasses={collapseCardClasses}
    >
      <List className={classes.list}>
        {invoiceItemInfo.map((info, index) => (
          <ListItem key={index} className={classes.listItem}>
            <ListItemText
              data-cy="auth-hold-item-data"
              primary={info.label}
              secondary={info.value}
              classes={listClasses}
            />
          </ListItem>
        ))}
      </List>
    </CollapseCard>
  );
};

const AuthorizationHoldItems = () => {
  const classes = useStyles();
  const { invoice, loading } = useSelector((state) => state.invoice);
  const items = invoice?.authorization_holds;

  return (
    <Card
      title={
        <Grid container alignItems="center" justifyContent="space-between">
          <span>{i18n.t('invoice.authorization_holds_title')}</span>
        </Grid>
      }
      headerActionType="vertical"
      datacy="authorization-holds-widget"
    >
      <Box className={classes.root}>
        {loading ? (
          <Box className={classes.loadingContainer}>
            <Loading />
          </Box>
        ) : (
          <>
            {items?.length > 0 ? (
              <>
                <Box
                  style={{
                    height: '100%',
                    maxHeight: 'calc(100% - 52px)',
                    overflowY: 'auto',
                  }}
                >
                  {items.map((item, index) => (
                    <ItemComponent item={item} key={index} />
                  ))}
                </Box>
              </>
            ) : (
              <Typography variant="h4">
                <Box fontSize={14}>{i18n.t('common.empty_list')}</Box>
              </Typography>
            )}
          </>
        )}
      </Box>
    </Card>
  );
};

ListTitleComponent.propTypes = {
  title: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
};

ItemComponent.propTypes = {
  item: PropTypes.object.isRequired,
};

export { AuthorizationHoldItems };
